"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeRefs = mergeRefs;
function assignRef(ref, value) {
  if (!ref) {
    return;
  }
  if (typeof ref === 'function') {
    ref(value);
  } else {
    ref.current = value;
  }
}
function mergeRefs(refs) {
  return value => {
    for (const ref of refs) {
      assignRef(ref, value);
    }
  };
}